import React, { Component } from 'react';
import {connect} from "react-redux";

import * as ActionTypes from "../../actions";

import ProductPlaceholder from "../../assets/product-placeholder.png";

const mapStateToProps = (state) => {
    return {
        configuratorId: state.configuratorId,
        facts: state.facts,
        products: state.products
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        fetchProduct: (id) => dispatch(ActionTypes.fetchProduct(id))
    };
};

class ProductConfiguratorImage extends Component {

    componentDidMount() {
        const {id, disableRefetch} = this.props;

        if ( ! disableRefetch) {
            this.props.fetchProduct(id);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {id} = this.props;

        if (prevProps.id && prevProps.id !== id) { // ID has changed ...
            this.props.fetchProduct(id);
        }
    }

    showvalueReducer = showvalue => (accumulator, currentValue) => {
        if (currentValue.showvalues.includes(showvalue)) {
            accumulator = currentValue;
        }
        return accumulator;
    };

    blockValueByComparingAttributeValuesReducer = (values, showvalueToGet, showvalueToCompare, value) => (accumulator, currentValue) => {
        const showvalueToGetValue = currentValue.values?.reduce(this.showvalueReducer(showvalueToGet));
        const showvalueToCompareValue = currentValue.values?.reduce(this.showvalueReducer(showvalueToCompare));

        if (showvalueToCompareValue.value[0].externalids[0].externalId === value) {
            accumulator = showvalueToGetValue;
        }

        return accumulator;
    };

    getValue(node, showvalue) {
        return node?.values?.reduce(this.showvalueReducer(showvalue), null);
    }

    getBlockValueByComparingAttributeValues(block, showvalueToGet, showvalueToCompare, value) {
        return block?.value?.reduce(this.blockValueByComparingAttributeValuesReducer(block.value, showvalueToGet, showvalueToCompare, value), null);
    }

    getPublicImageUrl(asset) {
        if (asset && asset.valuetype === 'ASSET') {
            const token = localStorage.getItem('xom_access_token');
            const href = asset?.value[0]?._links[2]?.href;

            return href?.replace('{?mimeType,width,height}', '?access_token=' + token);
        }

        return ProductPlaceholder;
    }

    render() {
        const {id, products, facts, configuratorId} = this.props;
        const product = products[id] ? products[id] : false;

        let color;
        switch (configuratorId) {
            case 'city_elements':
                color = facts.p_farbe_ce;
                break;
            case 'reno_elements':
                color = facts.p_farbe;
                break;
            case 'arini':
                color = facts.p_farbe;
                break;
            default:
                color = facts.p_farbe;
        }

        // const image = this.getValue(product, 'pk_produkt_bild');

        const configuratorImageBlock = this.getValue(product, "pk_bild_block");
        const colorKey = color.replace("RuleEngine:", "") + "_attr_Produktfarbe";
        const configuratorImage = this.getBlockValueByComparingAttributeValues(configuratorImageBlock, 'pk_bild', 'pk_farbe', colorKey);

        return product && (
            <img alt="" src={this.getPublicImageUrl(configuratorImage)} />
        );

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductConfiguratorImage);
